import React from 'react';
import styled from 'styled-components';
import { components } from 'react-select';
import DSSeparator from '@elliemae/ds-separator';
import { getGroupHeaderPosition } from './utils.js';

var GroupHeading = function GroupHeading(props) {
  var headerPosition = getGroupHeaderPosition(props.id);
  var hasSeparator = props.selectProps.options[headerPosition].hasSeparator;
  return /*#__PURE__*/React.createElement(Wrapper, null, hasSeparator && /*#__PURE__*/React.createElement(StyledSeparator, {
    type: "non-form"
  }), /*#__PURE__*/React.createElement(components.GroupHeading, props));
};

var StyledSeparator = /*#__PURE__*/styled(DSSeparator).withConfig({
  componentId: "sc-1bw0sto-0"
})(["width:auto;margin:", ";margin-top:unset;"], function (props) {
  return props.theme.space.xs;
});
var Wrapper = /*#__PURE__*/styled.div.withConfig({
  componentId: "sc-1bw0sto-1"
})(["display:flex;flex-direction:column;"]);

export default GroupHeading;
//# sourceMappingURL=GroupHeading.js.map
